import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import type { LeafCategoriesCarouselTitleProps } from './leafCategoriesCarouselTitle.types';

export const LeafCategoriesCarouselTitle: React.FC<LeafCategoriesCarouselTitleProps> = ({ query }) => (
    <h6 className="m-t-12 tbody-3">
        <I18n k="search_perseus.subcategory_tiles.title" params={{ query }} />
    </h6>
);
